import {useCallback} from 'react';

import {type Panel} from '../../util/panelTypes';
import {useRampFlagMediaSettingsDrawerAllTypesUser} from '../../util/rampFeatureFlags/rampFeatureFlags';
import {panelViews} from '../PanelBank/types';
import {type MediaBrowserPanelConfig} from './common';
import {DEFAULT_MEDIA_DRAWER_TYPES} from './supportedMediaDrawerTypes';
import {useGetMediaCardTypes} from './useGetMediaCardTypes';

export const useGetIsMediaPanelSettingsDrawerSupportedForPanel = (
  panel: Panel
) => {
  const mediaKeys =
    panel.viewType === panelViews.mediaBrowser
      ? (panel.config as MediaBrowserPanelConfig).mediaKeys
      : undefined;
  const getMediaCardTypes = useGetMediaCardTypes(mediaKeys);
  const isAllTypesEnabled = useRampFlagMediaSettingsDrawerAllTypesUser();
  return useCallback(() => {
    if (panel.viewType !== panelViews.mediaBrowser) {
      return false;
    }
    // Every media type has drawer settings, so skip the type lookup: it reads
    // sampled history keys and can miss the panel's key.
    if (isAllTypesEnabled) {
      return true;
    }
    // hook is only meant for a single panel which is only allowed to have one media type
    const mediaType = getMediaCardTypes()?.[0];
    return (
      mediaType != null && DEFAULT_MEDIA_DRAWER_TYPES.types.includes(mediaType)
    );
  }, [panel, getMediaCardTypes, isAllTypesEnabled]);
};
